import React, { useEffect, useState, useCallback }  from 'react';
import { motion } from "framer-motion";
import './index.scss';

import NoDataFound from "../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getCyberRatingStats } from "../../../../../../store/actions/thirdPartyRiskAction";

const CyberRate = () =>{

    const overallRiskScoreResponse = useSelector((state) => state.thirdPartyRisk.cyberRatingStats);

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [cyberRateLoading, setCyberRateLoading] = useState(false);
    const [cyberRatingStats, setCyberRatingStats] = useState(null);


    const fetchCyberRatingStats = useCallback(()=>{
        setCyberRateLoading(true);
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getCyberRatingStats(params))
    },[organizationId, domainId, scanId, dispatch])

    const getRatingClassName = (rating) => {
        if(rating === "A+") {
            return "a-plus-grade"
        } else if (rating === "A") {
            return "a-grade"
        } else if (rating === "B") {
            return "b-grade"
        } else if (rating === "C") {
            return "c-grade"
        } else if (rating === "D") {
            return "d-grade"
        } else if (rating === "F") {
            return "f-grade"
        } else {
            return "no-grade"
        }
    }


    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchCyberRatingStats();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchCyberRatingStats])

    useEffect(()=>{
        if(overallRiskScoreResponse !== null) {
            setCyberRateLoading(false);
            setCyberRatingStats(overallRiskScoreResponse);
        }
    },[overallRiskScoreResponse])

    const domainCyberRating = cyberRatingStats?.stats?.domain_cyber_rating;
    const overallRating = domainCyberRating?.overall_rating;

    return (
        <>
            <div className="bg-white-with-shadow p-4">
                {
                    cyberRateLoading ?
                    <SkeletonLoader type={"line"} count={7} currentPage={"cyberRate"} />
                    :
                    <motion.div
                        className="h-100"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        {
                            cyberRatingStats?.status === "failed" ?
                            <NoDataFound noDataText={cyberRatingStats?.description} />
                            :
                            <div className="cyber-rate-container">
                                <p className="heading">Cyber Rate</p>
                                <div className="grde-container rounded p-3 my-3 d-flex align-items-center gap-3">
                                    <h2 className="grade">{overallRating}</h2>
                                    <div className="grade-slider">
                                        <div className={`grade-inner ${getRatingClassName(overallRating)}`}>
                                            <span className="end-border"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="cyber-rate-list d-flex align-items-center flex-wrap">
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.application_vulnerability_rating)}`}><p>{domainCyberRating?.application_vulnerability_rating !== null ? domainCyberRating?.application_vulnerability_rating : "-"}</p></div>
                                        <p className="cyber-type">Application Vulnerabilities</p>
                                    </div>
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.infrastructure_configuration_risk_rating)}`}><p>{domainCyberRating?.infrastructure_configuration_risk_rating !== null ? domainCyberRating?.infrastructure_configuration_risk_rating : "-"}</p></div>
                                        <p className="cyber-type">Infrastructure <br></br>Configuration Risks</p>
                                    </div>
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.data_breach_and_leak_intelligence_rating)}`}><p>{domainCyberRating?.data_breach_and_leak_intelligence_rating !== null ? domainCyberRating?.data_breach_and_leak_intelligence_rating : "-"}</p></div>
                                        <p className="cyber-type">Data Breach & Leak <br></br>Intelligence</p>
                                    </div>
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.dns_security_rating)}`}><p>{domainCyberRating?.dns_security_rating !== null ? domainCyberRating?.dns_security_rating : "-"}</p></div>
                                        <p className="cyber-type">DNS Security</p>
                                    </div>
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.network_threat_rating)}`}><p>{domainCyberRating?.network_threat_rating !== null ? domainCyberRating?.network_threat_rating: "-"}</p></div>
                                        <p className="cyber-type">Network Threat</p>
                                    </div>
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.code_exposure_rating)}`}><p>{domainCyberRating?.code_exposure_rating !== null ? domainCyberRating?.code_exposure_rating : "-"}</p></div>
                                        <p className="cyber-type">Code Exposures</p>
                                    </div>
                                    <div className="cyber-rate-type d-flex align-items-center mb-4 gap-2">
                                        <div className={`grade-type ${getRatingClassName(domainCyberRating?.ip_reputation_rating)}`}><p>{domainCyberRating?.ip_reputation_rating !== null ? domainCyberRating?.ip_reputation_rating : "-"}</p></div>
                                        <p className="cyber-type">IP Reputation</p>
                                    </div>
                                </div>
                            </div>
                        }
                    </motion.div>
                }                   
            </div>
        </>
    )
}

export default CyberRate;